@if (content.header) {
  <div class="sky-club-tracker">
    <div class="sky-club-tracker__header">
      <span
        class="sky-club-tracker__header__title"
        [attr.aria-label]="content.header"
        role="heading"
        aria-level="3"
        [attr.data-cy]="content.header.split(' ').join('').toLowerCase()"
      >
        {{ content.header }}
      </span>
      @if (content.cards.length > 1) {
        <div class="sky-club-tracker__header__navigation">
          <button
            class="sky-club-tracker__header__navigation__previous"
            [ngClass]="{
              'sky-club-tracker__header__navigation__previous--disabled':
                carouselIndex === 0
            }"
            [attr.tabindex]="carouselIndex === 0 ? -1 : 0"
            (click)="previous()"
            role="button"
            aria-label="Previous"
            data-cy="previous_action_button"
          ></button>
          <button
            class="sky-club-tracker__header__navigation__next"
            [ngClass]="{
              'sky-club-tracker__header__navigation__next--disabled':
                carouselIndex === content.cards.length - 1
            }"
            [attr.tabindex]="
              carouselIndex === content.cards.length - 1 ? -1 : 0
            "
            (click)="next()"
            role="button"
            aria-label="Next"
            data-cy="next_action_button"
          ></button>
        </div>
      }
    </div>

    <div class="sky-club-tracker__carousel">
      <div class="sky-club-tracker__carousel__wrapper">
        <div class="sky-club-tracker__carousel__cards">
          @for (card of content.cards; track $index) {
            <div
              [ngClass]="
                !card.unlimited.unlocked
                  ? 'sky-club-tracker__card'
                  : 'sky-club-tracker-unlimited-card'
              "
            >
              @if ($index === carouselIndex) {
                <div
                  [ngClass]="
                    !card.unlimited.unlocked
                      ? 'sky-club-tracker__card__content'
                      : 'sky-club-tracker-unlimited-card__content'
                  "
                >
                  <div class="sky-club-tracker__card__content__left">
                    <span
                      [ngClass]="
                        !card.unlimited.unlocked
                          ? 'sky-club-tracker__card__content__left__title'
                          : 'sky-club-tracker-unlimited-card__content__left'
                      "
                      [attr.aria-label]="card.name"
                      role="text"
                      [attr.data-cy]="
                        card.name.split(' ').join('').toLowerCase() +
                        '_' +
                        $index
                      "
                    >
                      {{ card.name }}
                    </span>
                    @if (!card.unlimited.unlocked) {
                      <span
                        class="sky-club-tracker__card__content__left__description"
                        [attr.aria-label]="card.description"
                        role="text"
                        [attr.data-cy]="
                          card.name.split(' ').join('').toLowerCase() +
                          '_' +
                          $index
                        "
                      >
                        {{ card.description }}
                      </span>
                    }
                  </div>
                  <div
                    [ngClass]="
                      !card.unlimited.unlocked
                        ? 'sky-club-tracker__card__content__right'
                        : 'sky-club-tracker-unlimited-card__content__right'
                    "
                  >
                    @if (!card.unlimited.membership) {
                      <img
                        class="sky-club-tracker__card__content__right__image"
                        [src]="card.image?.src"
                        [alt]="card.image?.alt"
                        [attr.aria-label]="card.image?.alt"
                        [attr.data-cy]="
                          'sky_club_tracker_card_image' + '_' + $index
                        "
                      />
                    }
                  </div>
                </div>
                <div
                  [ngClass]="
                    !card.unlimited.unlocked
                      ? 'sky-club-tracker__card__footer'
                      : 'sky-club-tracker-unlimited-card__footer'
                  "
                >
                  @if (!card.unlimited.unlocked) {
                    <div
                      auraBadge
                      auraBadgeOutline="squared"
                      auraBadgeLabelColor="white"
                      class="sky-club-tracker__card__footer__visit-tracker"
                      [ngClass]="{
                        'sky-club-tracker__card__footer__visit-tracker--high':
                          card.visits?.scale === 'HIGH',
                        'sky-club-tracker__card__footer__visit-tracker--zero':
                          card.visits?.scale === 'ZERO',
                        'sky-club-tracker__card__footer__visit-tracker--low':
                          card.visits?.scale === 'LOW'
                      }"
                      [attr.data-cy]="
                        'sky_club_available_visits_' +
                        card.visits?.min +
                        '_card_' +
                        $index
                      "
                      [attr.aria-label]="
                        card.visits?.min +
                        ' ' +
                        card.visits?.ofLabel +
                        ' ' +
                        card.visits?.max +
                        ' ' +
                        card.visits?.label
                      "
                    >
                      {{ card.visits?.min }} {{ card.visits?.ofLabel }}
                      {{ card.visits?.max }}
                    </div>
                  }
                  @if (!card.unlimited.unlocked) {
                    <span
                      class="sky-club-tracker__card__footer__description"
                      [attr.data-cy]="
                        card.visits &&
                        card.visits.label.split(' ').join('').toLowerCase() +
                          '_' +
                          $index
                      "
                    >
                      {{ card.visits?.label }}
                    </span>
                  }
                  @if (!card.unlimited.unlocked) {
                    <button
                      [id]="'skyclub-tracker__tooltip--' + $index"
                      auraTooltip
                      aria-hidden="true"
                      [tooltipContent]="{
                        position: 'bottom-right',
                        trapFocus: true,
                        hideCloseIcon: false,
                        color: '#0b1f66',
                        info: card.visits?.tooltipInfo || ''
                      }"
                      class="sky-club-tracker__card__footer__icon"
                      [attr.aria-label]="card.visits?.tooltipInfo || ''"
                      [attr.data-cy]="'sky_club_tracker_tooltip_' + $index"
                      role="button"
                    >
                      <img
                        alt="Info Icon"
                        [attr.aria-label]="
                          card.visits?.min +
                          ' ' +
                          card.visits?.ofLabel +
                          ' ' +
                          card.visits?.max +
                          ' ' +
                          card.visits?.label +
                          ' ' +
                          'tooltip'
                        "
                        role="img"
                      />
                    </button>
                  }
                  @if (card.unlimited.unlocked || card.unlimited.membership) {
                    <div
                      class="sky-club-tracker-unlimited-card__footer__unlimited"
                    >
                      <span
                        class="sky-club-tracker-unlimited-card__footer__unlimited__title"
                        [attr.aria-label]="card.unlimited.title"
                        role="text"
                        [attr.data-cy]="
                          card.unlimited.title
                            .split(' ')
                            .join('')
                            .toLowerCase() +
                          '_' +
                          $index
                        "
                      >
                        {{ card.unlimited.title }}
                      </span>
                      <span
                        class="sky-club-tracker-unlimited-card__footer__unlimited__subtitle"
                        [attr.aria-label]="card.unlimited.subtitle"
                        role="text"
                        [attr.data-cy]="
                          card.unlimited.subtitle &&
                          card.unlimited.subtitle
                            .split(' ')
                            .join('')
                            .toLowerCase() +
                            '_' +
                            $index
                        "
                      >
                        {{ card.unlimited.subtitle }}
                      </span>
                      <div>
                        @if (card.unlimited.terms) {
                          <a
                            class="sky-club-tracker-unlimited-card__footer__unlimited__terms"
                            [id]="card.unlimited.terms.id || '#'"
                            [href]="card.unlimited.terms.url"
                            target="_blank"
                            [attr.data-cy]="
                              card.unlimited.terms.id + '_' + $index
                            "
                            [attr.aria-label]="
                              card.unlimited.terms.label +
                              ' open in a new window'
                            "
                          >
                            {{ card.unlimited.terms.label }}
                          </a>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
